import { cva } from '@mentimeter/ragnar-tailwind-config';

export const buttonVariants = cva(
  [
    'data-[has-state="false"]:disabled:bg-disabled-strong',
    'data-[has-state="false"]:disabled:text-on-disabled-strong',
    'data-[has-state="false"]:disabled:shadow-none',
    'disabled:cursor-not-allowed',
    'flex',
    'flex-row',
    'justify-center',
    'items-center',
    'text-center',
    'relative',
    'no-underline',
    'font-body',
    'font-semibold',
    'cursor-pointer',
    'rounded-full',
    'whitespace-nowrap',
    'opacity-100',
    'duration-300',
    'ease-in-out',
    'outline-transparent',
    'focus-visible:outline-solid',
    'focus-visible:outline-4',
    'focus-visible:outline-offset-2',
    'focus-visible:outline-interactive-focused',
  ],
  {
    variants: {
      size: {
        large: 'px-8 py-4 text-100 leading-125',
        default: 'px-6 py-3 text-87-5 leading-100',
        compact: 'px-4 py-2 text-87-5 leading-100',
      },
      state: {
        loading: [],
        success: [],
        error: [],
      },
      variant: {
        primary: [
          'bg-button-bg-primary',
          'text-on-primary',
          'data-[has-state="false"]:hover:bg-button-bg-primary-hover',
          'data-[has-state="false"]:active:bg-button-bg-primary-active',
        ],
        secondary: [
          'bg-transparent',
          'text-text',
          'data-[has-state="false"]:hover:bg-button-bg-secondary-hover',
          'data-[has-state="false"]:active:bg-button-bg-secondary-active',
        ],
        tertiary: [
          'bg-button-bg-tertiary',
          'text-text',
          'data-[has-state="false"]:hover:bg-button-bg-tertiary-hover',
          'data-[has-state="false"]:active:bg-button-bg-tertiary-active',
        ],
        brand: [
          'bg-button-bg-brand',
          'text-on-brand',
          'data-[has-state="false"]:hover:bg-button-bg-brand-hover',
          'data-[has-state="false"]:active:bg-button-bg-brand-active',
        ],
        outline: [
          'text-text',
          'bg-transparent',
          'shadow-[inset_0_0px_0px_2px_var(--color-primary)]',
          'data-[has-state="false"]:hover:bg-button-bg-outline-hover',
          'data-[has-state="false"]:active:bg-button-bg-outline-active',
        ],
        primaryReverse: [
          'text-text',
          'bg-button-bg-primary-reverse',
          'data-[has-state="false"]:hover:bg-button-bg-primary-reverse-hover',
          'data-[has-state="false"]:active:bg-button-bg-primary-reverse-active',
          'data-[has-state="false"]:focus-visible:bg-button-bg-primary-reverse',
        ],
        subtle: [
          'bg-transparent',
          'text-text',
          'border-border-transparent',
          'data-[has-state="false"]:hover:bg-transparent',
          'data-[has-state="false"]:hover:border-border-transparent',
          'data-[has-state="false"]:active:bg-transparent',
          'data-[has-state="false"]:active:border-border-transparent',
          'rounded-none',
          'py-0.5',
          'px-0.5',
          'data-[has-state="false"]:disabled:bg-transparent',
          'data-[has-state="false"]:disabled:text-text-disabled',
        ],
        positive: [
          'bg-button-bg-positive',
          'text-on-positive',
          'data-[has-state="false"]:hover:bg-button-bg-positive-hover',
          'data-[has-state="false"]:active:bg-button-bg-positive-active',
        ],
        negative: [
          'bg-button-bg-negative',
          'text-on-negative',
          'data-[has-state="false"]:hover:bg-button-bg-negative-hover',
          'data-[has-state="false"]:active:bg-button-bg-negative-active',
        ],
        negativeWeak: [
          'bg-button-bg-negative-weak',
          'text-on-negative-weak',
          'data-[has-state="false"]:hover:bg-button-bg-negative-weak-hover',
          'data-[has-state="false"]:active:bg-button-bg-negative-weak-active',
        ],
      },
    },
    defaultVariants: {
      variant: 'tertiary',
      size: 'default',
    },
  },
);
